const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'registration',
        'slider',
    ],

    methods: {
        focusTabGranted(registerSecret){
            const storage = this.getStorage()
            const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}
            const {
                employeeID,
                applicationCompletedAt,
            } = employee
            const applicationCompleted = applicationCompletedAt || this.model.stepComplete.editFinish

            const registryKeys = Object.keys(this.registry)
            const viewIndex = utils.indexOf(registryKeys, registerSecret)
            const editViewIndex = utils.indexOf(registryKeys, 'editBase')
            const finishViewIndex = utils.indexOf(registryKeys, 'finish')
            let result = true
            let tabContentContainer, propertiesForm

            // no premature emailActivation text display
            if(!employeeID && registerSecret === 'emailActivation' && !this.model.stepComplete.register) {
                result = false

                tabContentContainer = this.getTabComponent('register', false)
                if(tabContentContainer){
                    tabContentContainer.find('templates_registration_form', form => {
                        propertiesForm = form
                    })
                }

                if(propertiesForm){
                    propertiesForm.submit()
                        .fail(status => {
                            if(status === 'validationFailed' && this.model.activeRegisterSecret !== 'register'){
                                this.focusTab('register', true)
                            }
                        })

                } else {
                    result = true
                    this.stepComplete()
                }

            }
            // profile management requires a user to be logged in
            else if (!employeeID && viewIndex >= editViewIndex){
                result = false
                this.focusTab('login', true)
            }
            // application complete users get to see finish step only
            else if(employeeID && applicationCompleted && viewIndex < finishViewIndex) {
                result = false
                this.focusTab('finish', true)
            }
            // application incomplete logged-in users have to manage their profile
            else if(employeeID && !applicationCompleted && viewIndex < editViewIndex) {
                result = false
                this.focusTab('editBase', true)
            }
            // application incomplete logged-in users have to manage their profile step by step
            else if(employeeID && !applicationCompleted && viewIndex > editViewIndex) {
                result = false
                let invalidMandatoryStepFound = false

                for(let mandatoryViewIndex = editViewIndex; mandatoryViewIndex < Math.min(finishViewIndex, viewIndex); mandatoryViewIndex++) {
                    const mandatoryViewRegisterSecret = registryKeys[mandatoryViewIndex]

                    if(!this.model.stepComplete[mandatoryViewRegisterSecret]){

                        tabContentContainer = this.getTabComponent(mandatoryViewRegisterSecret, false)
                        if(tabContentContainer){
                            tabContentContainer.find('templates_registration_form', form => {
                                propertiesForm = form
                            })
                        }

                        if(propertiesForm){
                            invalidMandatoryStepFound = true
                            propertiesForm.submit()
                        } else {
                            this.focusTab(mandatoryViewRegisterSecret, true)
                        }

                        break
                    }
                }

                if(!invalidMandatoryStepFound){
                    result = true
                }
            }

            return result
        },
    }
}